<template>
  <div class="admin col-12">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Plant Topping</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="temp in toppings">
            <div
              class="row clickable"
              :key="temp.id"
              v-show="temp.active == !show_deleted"
              v-bind:class="{ selected: temp == item }"
              @click="_itemSelected(temp)"
            >
              <div class="col-12">
                {{ temp.description }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <ToppingDetail
            :selectedItem="item"
            class="col-12"
            v-show="showToppingDetail"
            ref="topping_detail"
            @new="_new_item"
          />
        </div>
      </div>
    </div>

    <CreateTopping
      ref="topping_modal"
      v-show="showCreateTopping"
      @close="_closeNewModal"
    />

    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted"> Show Deleted </label>
      </div>
    </div>
  </div>
</template>

<script>
import ToppingDetail from "@/components/admin/inventory/detail/ToppingDetail.vue";
import CreateTopping from "@/components/admin/inventory/create/CreateTopping.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ManageToppingVariety",

  // DATA
  data: () => ({
    item: null,
    loading: false,
    show_deleted: false,
    showCreateTopping: false,
    showToppingDetail: true,
  }),

  // COMPUTED - TODO
  computed: {
    ...mapState("inventory", ["toppings", "new_topping"]),
  },

  // MOUNTED
  mounted() {
    this.$nextTick(() => {
      this.getToppings();
    });
  },

  // WATCH
  watch: {
    new_topping(new_value) {
      this.item = new_value;
      this.$refs.topping_modal.clear();
    },
  },

  // METHODS
  methods: {
    // ...mapActions("inventory", ["apiCreatePlantBotany", "getPlantBotanys"]),
    ...mapActions("inventory", ["apiCreateTopping", "getToppings"]),

    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },

    _save() {
      this.$refs.topping_detail.save();
    },

    _new_item() {
      this.showCreateTopping = true;
    },

    _closeNewModal() {
      this.showCreateTopping = false;
    },

    _showTab(index) {
      this.tab = index;
    },

    _itemSelected(item) {
      this.item = item;
      this.showToppingDetail = true;
    },

    _delete_item() {
      if (this.item != null && this.item.id > 0) {
        this.item.active = !this.item.active;
        this.apiSaveTopping(this.item);
      }
    },
  },

  // COMPONENTS
  components: {
    ToppingDetail,
    CreateTopping,
  },
};
</script>
